var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.0264H16.5L14.5 15.0264H10.5L8.5 12.0264H2.5",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95 5.13637L2.5 12.0264V18.0264C2.5 18.5568 2.71071 19.0655 3.08579 19.4406C3.46086 19.8157 3.96957 20.0264 4.5 20.0264H20.5C21.0304 20.0264 21.5391 19.8157 21.9142 19.4406C22.2893 19.0655 22.5 18.5568 22.5 18.0264V12.0264L19.05 5.13637C18.8844 4.80315 18.6292 4.52274 18.313 4.32665C17.9967 4.13056 17.6321 4.02656 17.26 4.02637H7.74C7.36792 4.02656 7.00326 4.13056 6.68704 4.32665C6.37083 4.52274 6.11558 4.80315 5.95 5.13637Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/Inbox.2ae9ce98bf2a823dd2e56f8ed869a762.svg";
export { ForwardRef as ReactComponent };